export default "__VITE_ASSET__2cWNX09d__"